import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IonItemSliding} from '@ionic/angular';
import {RankDto, UserClockInDto} from '../../../../../Models/Rrhh/Clock-In/clock-in-list.interface';
import {ClockInStatusEnum} from '../../../../../Shared/Enum/clock-in-status.enum';
import {ControllerComponent} from '../../../../Controller/controller-component';

@Component({
  selector: 'app-user-clock-in-item',
  templateUrl: './user-clock-in-item.component.html',
  styleUrls: ['./user-clock-in-item.component.scss'],
  standalone: false
})
export class UserClockInItemComponent extends ControllerComponent {

  @Input() item!: UserClockInDto;
  @Input() isMine: boolean = false;

  @Output() clickEdit: EventEmitter<RankDto> = new EventEmitter<RankDto>();
  @Output() clickSign: EventEmitter<RankDto> = new EventEmitter<RankDto>();

  protected readonly clockInStatusEnum = ClockInStatusEnum;


  /**
   * Acción sobre la opción del slide
   *
   */
  doSlideAction(action: string, rank: RankDto, itemSld: IonItemSliding) {
    itemSld.close();

    switch (action) {
      case 'edit':
        this.clickEdit.emit(rank);
        break;

      case 'sign':
        this.clickSign.emit(rank);
        break;
    }
  }

}
